import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import BusBooking from './pages/BusBooking';
import Routes from './pages/Routes';
import Schedules from './pages/Schedules';
import MyBookings from './pages/MyBookings';
import Contact from './pages/Contact';
import About from './pages/About';
import TermsAndConditions from './pages/TermsAndConditions';
import TicketPolicy from './pages/TicketPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ManagerDashboard from './pages/ManagerDashboard';
import VehicleManagement from './pages/VehicleManagement';
import RouteManagement from './pages/RouteManagement';
import ScheduleManagement from './pages/ScheduleManagement';
import CityManagement from './pages/CityManagement';
import PaymentCallback from './pages/PaymentCallback';
import Checkout from './pages/Checkout';
import AdminBooking from './pages/AdminBooking';
import DriverDashboard from './pages/DriverDashboard';
import SeatStatus from './pages/SeatStatus';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import CacheBuster from './components/CacheBuster';

function App() {
  return (
    <>
      <CacheBuster />
      <ScrollToTop />
      <RouterRoutes>
        {/* Routes without Layout */}
        <Route path="/driver/dashboard" element={<DriverDashboard />} />
        <Route path="/seat-status" element={<SeatStatus />} />
        
        {/* Routes with Layout */}
        <Route path="/" element={<Layout><Dashboard /></Layout>} />
        <Route path="/book" element={<Layout><BusBooking /></Layout>} />
        <Route path="/checkout" element={<Layout><Checkout /></Layout>} />
        <Route path="/routes" element={<Layout><Routes /></Layout>} />
        <Route path="/schedules" element={<Layout><Schedules /></Layout>} />
        <Route path="/bookings" element={<Layout><MyBookings /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/terms" element={<Layout><TermsAndConditions /></Layout>} />
        <Route path="/ticket-policy" element={<Layout><TicketPolicy /></Layout>} />
        <Route path="/privacy" element={<Layout><PrivacyPolicy /></Layout>} />
        <Route path="/manager" element={<Layout><ManagerDashboard /></Layout>} />
        <Route path="/vehicles" element={<Layout><VehicleManagement /></Layout>} />
        <Route path="/route-management" element={<Layout><RouteManagement /></Layout>} />
        <Route path="/schedule-management" element={<Layout><ScheduleManagement /></Layout>} />
        <Route path="/city-management" element={<Layout><CityManagement /></Layout>} />
        <Route path="/payment/callback" element={<Layout><PaymentCallback /></Layout>} />
        <Route path="/admin/booking" element={<Layout><AdminBooking /></Layout>} />
        
        {/* Catch-all route for 404 - must be last */}
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </RouterRoutes>
    </>
  );
}

export default App; 